import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from '../general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-verify-payment',
  templateUrl: './verify-payment.component.html',
  styleUrls: ['./verify-payment.component.css']
})
export class VerifyPaymentWalletComponent implements OnInit{
  constructor(
    private route:ActivatedRoute, 
    private toaster: ToastrService,
    private s:GeneralService,
    private r:Router
    ){}
  ngOnInit(): void {
    let ref = ''
    let gateway = ''
     if(this.route.snapshot.queryParams['reference']){
       ref = this.route.snapshot.queryParams['reference']
       gateway = 'paystack'
    }else{
        gateway = 'flutterwave'
       ref = this.route.snapshot.queryParams['transaction_id']
    }
      this.confirm(ref, gateway);
  }

  confirm(reference:string, gateway:string) {
    this.s.loader = true;
    this.s
      .verifyPayment(reference, gateway)
      .subscribe((data: { [key: string]: any }) => {
        this.s.loader = false;
        if (data['message'] == 'Wallet fund successfully') {
          this.s.getWalletBal().subscribe((r) => {
            localStorage.setItem('wallet', JSON.stringify(r.data));
            this.r.navigateByUrl('main/profile')
            this.toaster.success('Wallet funded successfully');
          });
        } 
      })
    }
}
